import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import {
  DeleteNegotiation,
  deleteManageEnvelope,
  negotiationDetails,
} from "../../../../services/CommonService";

function NegotiationDelete(props) {
  const closeModalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  // ✅ Utility: close modal and clean fade backdrop
  const closeBootstrapModal = () => {
    const modalEl = document.getElementById("deleteNegotiationModal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);

    if (modalInstance) {
      modalInstance.hide(); 
    }

    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }, 300);
  };

  const hideDeleteNegotiation = (e) => {
    e.preventDefault();
    closeBootstrapModal();
    props.onClose?.();
  };

  const onDestroyNegotiation = async (e) => {
    e.preventDefault();

    if (props.id > 0) {
      try {
        setLoading(true);

        // Step 1: negotiation delete API
        const response = await DeleteNegotiation({
          negotiation_id: props.id,
        });

        const message =
          response?.data?.message || "Negotiation deleted successfully!";
        toast.success(message);

        // Step 2: Get negotiation details to check if envelope needs deletion
        try {
          const detailsRes = await negotiationDetails({ negotiation_id: props.id });
          const deletedNegotiation = detailsRes?.data?.data ?? detailsRes?.data ?? null;

          if (deletedNegotiation) {
            const { status_id, envelope_id, envelope_uuid } = deletedNegotiation;

            // Step 3: Delete envelope if needed
            const shouldDeleteEnvelope = [3, 4, 5].includes(Number(status_id));
            if (shouldDeleteEnvelope && (envelope_id || envelope_uuid)) {
              try {
                await deleteManageEnvelope({ envelope_id });
              } catch (envErr) {
                console.error("Failed to delete envelope:", envErr);
              }
            }
          }
        } catch (detailsErr) {
          console.error("Failed to fetch negotiation details:", detailsErr);
        }

        // Step 4: update parent table
        if (props.onDeleted) props.onDeleted(props.id);

        // Step 5: close modal and cleanup fade
        closeBootstrapModal();
        props.onClose?.();
      } catch (err) {
        toast.error(Utils.getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Oops...something went wrong.");
    }
  };

  return (
    <div
      className="modal fade"
      id="deleteNegotiationModal"
      tabIndex="-1"
      aria-labelledby="deleteNegotiationModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="deleteNegotiationModalLabel">
              Delete Negotiation
            </h5>
            <button
              type="button"
              ref={closeModalRef}
              onClick={hideDeleteNegotiation}
              className="btn btn-close close_btn text-reset mb-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="bi bi-x-circle" aria-hidden="true" />
            </button>
          </div>

          <div className="modal-body">
            <p>Are you sure you want to delete this negotiation?</p>
            <p>Deleted negotiations cannot be recovered.</p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={hideDeleteNegotiation}
              data-bs-dismiss="modal"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onDestroyNegotiation}
              disabled={loading}
            >
              {loading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NegotiationDelete;
